import { styled } from '@mui/material/styles';
import AppBoxShadows from 'common/theme/AppBoxShadows';
import { DataGrid } from 'libs/mui/data-grid/components/data-grid.component';
import GridColumnMenu from 'libs/mui/data-grid/components/grid-column-menu.component';
import GridColumnsPanel from 'libs/mui/data-grid/components/grid-columns-panel.component';

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '&.MuiDataGrid-root': {
    fontSize: theme.typography.caption.fontSize,
  },
  '& .MuiDataGrid-scrollbar--vertical': {
    overflowY: 'scroll',
  },
  '& .MuiDataGrid-topContainer .MuiDataGrid-sortIcon': {
    color: theme.palette.Buttons.Tertiary.LabelDefault,
  },
  '& .MuiDataGrid-container--top [role=row]': {
    backgroundColor: theme.palette.Background,
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    backgroundColor: theme.palette.Container.Bg,
  },
  '& .MuiDataGrid-topContainer': {
    color: theme.palette.SkillChip.TextDefault,
  },
  '& .MuiDataGrid-row': {
    color: theme.palette.Text.Headline,
    '&:hover': {
      backgroundColor: theme.palette.LinkContainer.BgHover,
    },
  },
  // Prevent the pinned grid actions column to shift position depending on the presence of the vertical scrollbar
  '& .gridActions.MuiDataGrid-columnHeader--pinnedRight, & [data-field="gridActions"].MuiDataGrid-cell--pinnedRight':
    {
      right: '0 !important',
    },
  // Grid actions are just for displaying the button on the header so the body of the column should be hidden
  '& .MuiDataGrid-row, & .MuiDataGrid-row:hover': {
    '& [data-field="gridActions"].MuiDataGrid-cell--pinnedRight': {
      // Hiding everything except the bottom border to prevent an empty gap when scrolled all the way to the right
      borderLeft: 'none',
      background: 'none',
      pointerEvents: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader.gridActions': {
    overflow: 'visible',
    padding: '0 4px',
    outline: 'none',
    borderLeft: 'none',
    backgroundColor: theme.palette.Background,
    '.MuiDataGrid-columnHeaderDraggableContainer': {
      width: 30,
    },
    '.MuiDataGrid-columnHeaderTitleContainer': {
      overflow: 'visible',
    },
    '.MuiDataGrid-menuIcon': {
      width: 'auto',
      visibility: 'visible',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    '.MuiIconButton-root:hover': {
      backgroundColor: theme.palette.Icons.Secondary.BgHover,
    },
    '.MuiIconButton-root .MuiSvgIcon-root': {
      color: theme.palette.Icons.Secondary.IconFill,
    },
  },
}));

export const StyledColumnMenu = styled(GridColumnMenu)(({ theme }) => ({
  '&': { boxShadow: AppBoxShadows.shadow3, backgroundColor: theme.palette.Card.Bg },
  '& .MuiListItemText-primary': {
    fontSize: theme.typography.body3.fontSize,
  },
}));

export const StyledColumnsPanel = styled(GridColumnsPanel)(({ theme }) => ({
  '&': {
    backgroundColor: theme.palette.Card.Bg,
  },
  '& .MuiPaper-root.MuiPaper-elevation': {
    boxShadow: AppBoxShadows.shadow1,
    backgroundColor: theme.palette.Card.Bg,
  },
  '& .MuiDataGrid-columnsManagementRow.Mui-disabled': {
    display: 'none',
  },
  '& .MuiTypography-root': {
    fontSize: theme.typography.body3.fontSize,
    lineHeight: 2,
  },
  '& .MuiInputBase-root': {
    borderRadius: '0.75rem',
    fontSize: theme.typography.body2.fontSize,
    '& .MuiOutlinedInput-input': {
      WebkitBoxShadow: 'none',
    },
    '& .MuiInputAdornment-positionStart:first-of-type': {
      position: 'absolute',
      right: 0,
    },
    '& .MuiInputAdornment-positionStart:first-of-type .MuiSvgIcon-root': {
      backgroundColor: theme.palette.Icons.Primary.BgDefault,
      color: theme.palette.Icons.Primary.IconFill,
      borderRadius: '50%',
      padding: '4px',
      height: '22px',
      width: '22px',
    },
  },
  '& .MuiInputBase-root:hover, & .MuiInputBase-root.Mui-focused': {
    '.MuiInputAdornment-positionStart:first-of-type .MuiSvgIcon-root': {
      color: theme.palette.Icons.Primary.IconFill,
      cursor: 'default',
    },
  },
}));
